import { render, staticRenderFns } from "./EnviadasComentarios.vue?vue&type=template&id=02a30f80"
import script from "./EnviadasComentarios.vue?vue&type=script&lang=js"
export * from "./EnviadasComentarios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports